export default {"modal":"_modal_q32c0_11","slideUp":"_slideUp_q32c0_1","modalBackground":"_modalBackground_q32c0_21"};